import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { FinancialTaxesItemModel } from '../types';

const taxFailureTypes = ['File', 'Pay', 'Both'];

export const financialTaxesItemValidator: ValidateJSModel<FinancialTaxesItemModel> = {
  Failure: {
    hasValue: {
      validator: {
        inclusion: taxFailureTypes,
      },
    },
  },

  Year: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireMonth: false,
      requireDay: false,
      earliest: options?.applicantBirthdate,
      latest: DEFAULT_LATEST,
    },
  }),

  Reason: { hasValue: true },

  Agency: { hasValue: true },

  TaxType: { hasValue: true },

  Amount: {
    model: {
      validator: {
        value: {
          presence: true,

          /* Add validation for total amount range (0 - 2,147,483,647) */
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 2147483647,
            notGreaterThanOrEqualTo: 'error.currency.min',
            notLessThanOrEqualTo: 'error.currency.max',
          },
        },
        name: {},
      },
    },
  },

  Date: (value, attributes) => {
    if (attributes?.DateNotApplicable?.applicable === false) { return {}; }

    return {
      presence: true,
      date: {
        requireDay: false, latest: DEFAULT_LATEST, earliest: attributes?.Year, tooEarly: 'error.taxesSatisfied.min'
      },
    };
  },

  Description: { hasValue: true },

  YearEstimated: {},

  AmountEstimated: {},

  DateNotApplicable: {},
};
